// This file is generated via scripts/build-static-config.js
// Do not modify directly as changes will be overwritten in CI

export const CONFIGURATION = {
  country: 'ch',
  brand: 'bk',
  env: 'prod',
  graphqlEnv: 'prod',
  graphqlGatewayEnv: '',
  sanityEnv: 'prod',
  platform: 'web',
  commitRef: 'ad5c95e9f52dd692e6771cbee0c2c2c56a2eef52',
  releaseTimestamp: '1680251755',
  sanityDataset: '',
  sanityProjectId: 'czqk28jt',
  appFlowBuildId: '',
  adyen: {
    clientKey: 'live_L6BRV3FK4FFZVN2XFXYC6WCMRALGGK6O',
    environment: 'live',
    urlPrefix: 'https://checkoutshopper-live.adyen.com',
    ideal: {
      idealBanks: [],
    }
  },
  apiKeys: {
    amplitude: '',
    branch: 'key_live_ekX2Ww4SVYojRlaP5tvFppgmFBd9hVXS',
    braze: '56e3860e-5510-4a3b-80ed-4ac999662b43',
    bringg: '',
    googleMaps: 'AIzaSyDOtGSKPthz3am_QTmuavFu42QiIcVORm0',
    googleAnalytics: '',
    tomtom: '',
    launchDarkly: '5f99e1022162e808bba30799',
    launchDarklyMobileKey: '',
    logRocket: 'mj7uvx/ctg-prod',
    mParticle: 'eu1-4d9fc3be5c3c8146a35db8f2e7290be2',
    radar: '',
  },
  apple: {
    merchantId: 'merchant.com.bk.native.adyen.prod',
    migrationMerchantId: '',
    paymentsNetworks: ['AmEx','MasterCard','Visa','Discover'],
    prepaidMerchantId: '',
    migrationPrepaidMerchantId: '',
  },
  aws: {
    gqlApiUrl: 'https://use1-prod-bk.rbictg.com/graphql',
    gqlGatewayApiUrl: 'https://use1-prod-bk-gateway.rbictg.com/graphql',
    region: 'us-east-1',
    userPoolClientId: '1ca8tuisf8vnaffhfck2258idt',
    userPoolId: 'us-east-1_BCVUfvjft',
  },
  bringg: {
    region: '5',
  },
  datadog: {
    logs: {
      clientToken: 'pubf86c7fbda9db5464a9cf21d924cd74db',
      dataCenter: '',
    },
    rum: {
      applicationId: 'cf8d1c33-af85-481b-b4b7-ce00a7ec999d',
      clientToken: 'pubf86c7fbda9db5464a9cf21d924cd74db',
      dataCenter: '',
    },
  },
  firstData: {
    corporateStoreId: '',
  },
  forter: {
    siteId: '6ebc7d54b003',
  },
  google: {
    paymentsEnvironment: 'prod',
    paymentsGateway: 'firstdata',
    paymentsGatewayMerchantId: {
      ca: '',
      us: '456031998994',
    },
    migrationPaymentsGateway: '',
    migrationPaymentsGatewayMerchantId: {
      ca: '',
      us: '',
    },
    paymentsNetworks: ['AMEX','MASTERCARD','VISA','DISCOVER','JCB'],
    prepaidPaymentsGateway: '',
    prepaidPaymentsGatewayMerchantId: {
      ca: '',
      us: '',
    },
    migrationPrepaidPaymentsGateway: '',
    migrationPrepaidPaymentsGatewayMerchantId: {
      ca: '',
      us: '',
    }
  },
  googleAdManager: {
    campaignId: '',
  },
  googleTagManager: {
    containerId: 'GTM-P8PDD5W',
  },
  oneTrust: {
    cookieCompliance: {
      consentCategoryBranch: 'C0004',
      consentCategoryBraze: 'C0002',
      consentCategoryMParticle: 'C0001',
      globalConsentState: 'Opt-Out',
      scriptUrl: '',
      scriptId: '',
    },
    deleteAccountUrl: '',
  },
  pypestream: {
    scriptUrl: '',
    appId: '',
  },
  restaurants: {
    displayEnv: 'prod',
    validMobileOrderingEnvs: ['alpha','beta','live'],
  },
  urls: {
    braze: 'https://sdk.fra-01.braze.eu',
    firstData: 'https://api.payeezy.com',
    firstDataTh: '',
    webBaseUrl: 'https://www.burger-king.ch',
    thDigital: '',
  },
  tokenEx: {
    publicKey: '',
  },
  vrPayment: {
    braintreeTokenizationKey: '',
  },
  orbital: {
    baseUrl: '',
    subscriberId: '',
    pieFormat: '',
    mode: '',
  },
  timeFormat: '',
  dateFormat: '',
  maxCartQuantity: '',
  appStoreDeeplink: '',
};